import PropTypes from 'prop-types';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './styles';

// Single-mode theme provider (light only). The dark-mode
// prototype was rolled back — too many feature stylesheets bake
// in hardcoded #fff backgrounds, gray text, and non-theme-aware
// hover states (DayPilot timeplan calendar, Ranks SortableList,
// Crew-Changes "planned" row striping, Users SeafarersView,
// Vacancies). Tracked as deferred work in docs/migration/tech-debt.md.
//
// CssBaseline resets browser defaults and gives us the typography
// + scrollbar overrides defined in styles.js. StyledEngineProvider
// keeps emotion's stylesheets ahead of MUI's so user-side CSS
// keeps working.
const ThemeProvider = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  </StyledEngineProvider>
);

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
